import styled from "styled-components";

export const DateTimeInput = styled.input`
  /* Style de base */
  width: 100%;

  /* Styles spécifiques pour Safari iOS */
  @supports (-webkit-touch-callout: none) {
    -webkit-appearance: none;
    appearance: none;
    min-width: 100%;
  }
`;
